// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wCQImHWE1_NX9r {
  box-sizing: border-box;
  border: none;
  outline: none;
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  padding: 8px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  width: 100%;
  height: 40px;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-150, 12px);
}
.LbvQujkHxrXm_Q {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.AeIpekVD5YmmDq,
.AeIpekVD5YmmDq:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.DZzGXBlDLdGQj7 {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
`, ""]);
// Exports
export var input = `wCQImHWE1_NX9r`;
export var input_focus = `LbvQujkHxrXm_Q`;
export var input_invalid = `AeIpekVD5YmmDq`;
export var input_disabled = `DZzGXBlDLdGQj7`;
export default ___CSS_LOADER_EXPORT___;
